module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c(_vm.activeBetComponent, {
    tag: "component",
    attrs: {
      "name": _vm.specialBetName,
      "actions": _vm.actions,
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), (_vm.isSystemBet) ? _c('system-bet') : _vm._e(), _vm._v(" "), (_vm.isFutureBet) ? _c('future-bet') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-611da673","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/main/Betting.vue
// module id = 404
// module chunks = 0